// Çek / Senet Durum Değiştir penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.changeCheckStatus';

export const changeCheckStatusGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Çek / senet durumu nasıl değiştirilir?'),
  intro: t(`${G}.intro`, 'Çek veya senedin yaşam döngüsünü buradan ilerletirsiniz. Her durumun kasa, banka ve cari üzerindeki etkisi farklıdır; aşağıda tek tek açıklanmıştır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Belge ve mevcut durum'),
    body: t(`${G}.regions.body`, 'Yeni durum ve bilgiler'),
    footer: t(`${G}.regions.footer`, 'Onayla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Mevcut durumu kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstte Belge, Mevcut Durum, Tutar ve Kalan Tutar görünür. Altında yalnız bu durumdan geçilebilecek yeni durumlar düğme olarak listelenir; birini seçince ne yapacağı kısa bir kutuda yazar.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tahsil Edildi, Ciro Edildi, İade Edildi, İptal Edildi ve Ödendi son durumlardır; bunlardan başka duruma geçilemez.'),
        t(`${G}.s1.tip2`, 'Senetlerde Tahsilde, Kısmi Tahsil ve Karşılıksız seçenekleri çıkmaz; senet Portföyde\'den doğrudan Tahsil Edildi\'ye alınır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tahsile verme ve tahsilat (alınan)'),
      text: t(`${G}.s2.text`, 'Tahsilde: çek bankaya tahsile verilir; Banka Hesabı seçilir, para hareketi oluşmaz. Tahsil Edildi / Kısmi Tahsil: Tahsilat Tutarı\'nı ve Tahsilat Yöntemi\'ni seçin. Kasa seçilirse tutar o kasaya, Banka seçilirse o banka hesabına girer; Elden Teslim\'de kasa / banka hareketi oluşmaz. Cari değişmez, çünkü cari kayıt anında zaten alacaklandırıldı.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tahsil Edildi\'de kalan tutardan az girerseniz kısmi tahsilat yapılır: durum değişmez, kalan tutar azalır.'),
        t(`${G}.s2.tip2`, 'Kısmi Tahsil yalnız Tahsilde olan çekte çıkar ve birden çok kez yapılabilir; tutar kalan tutarı geçemez.'),
        t(`${G}.s2.tip3`, 'Tahsilde olan çekte yöntem Banka gelir ve tahsile verildiği banka (alt) hesabı seçili olur; başka bir banka hesabı da seçebilirsiniz. Kasa veya Elden Teslim seçerseniz uyarı çıkar ve para bankaya yazılmaz (kasaya girer ya da hareket oluşmaz).'),
        t(`${G}.s2.tip4`, 'Tahsilde olan çek gerekirse yeniden Portföyde\'ye alınabilir; para hareketi oluşmaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ciro ve teminat (alınan)'),
      text: t(`${G}.s3.text`, 'Ciro Edildi: elinizdeki çeki / senedi başka bir cariye verirsiniz. Ciro Edilecek Cari zorunludur; o cari tutar kadar borçlandırılır, kasa / banka değişmez. Teminatta: çek / senet bankaya teminat olarak verilir; Banka Hesabı zorunludur, para hareketi oluşmaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Teminattaki kayıt Teminattan İade (hareket yok) veya Tahsil Edildi yapılabilir. Teminattan iade edilen kayıt yeniden Portföyde\'ye veya Tahsilde\'ye alınabilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Karşılıksız, iade ve iptal (alınan)'),
      text: t(`${G}.s4.text`, 'Karşılıksız (yalnız çek): kayıtta yazılan cari hareket ters çevrilir, müşteri yeniden borçlanır. İade Edildi: çek / senet sahibine geri verilir, müşteri yeniden borçlanır. İptal Edildi: kayıt iptal edilir, cari hareket ters çevrilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Karşılıksız çek daha sonra tahsil edilirse (Tahsil Edildi) müşteri yeniden alacaklandırılır ve tutar seçilen kasa / bankaya girer.'),
        t(`${G}.s4.tip2`, 'Karşılıksız çek İade Edildi yapılırsa cari ikinci kez değiştirilmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Verilen çek / senet durumları'),
      text: t(`${G}.s5.text`, 'Verilen kayıtlar "Ödenmedi" ile başlar. Ödendi: Banka Hesabı zorunludur; tutar o banka hesabından çıkar, cari değişmez. İade Alındı: tedarikçiden geri aldınız; tedarikçi alacaklandırılır, yani çekle yaptığınız ödeme geri alınır. Karşılıksız (yalnız çek) ve İptal Edildi de tedarikçiyi alacaklandırır.'),
      tips: [
        t(`${G}.s5.tip1`, 'İade alınan kayıt gerekirse yeniden Ödenmedi durumuna alınabilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Tarih, açıklama ve onay'),
      text: t(`${G}.s6.text`, 'İşlem Tarihi bugünle gelir, değiştirebilirsiniz; kasa / banka hareketi de bu tarihle yazılır. Açıklama isteğe bağlıdır. "Onayla" bir durum seçilince açılır. Her değişiklik detay penceresindeki İşlem Geçmişi\'ne yazılır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Tahsil Edildi, Kısmi Tahsil veya Ödendi\'de kasa / banka hareketi oluşturulamazsa durum değişikliği geri alınır ve hata gösterilir.'),
      ],
    },
  ],
});
